import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './RequiredTip.module.scss'
const cx = cn.bind(s)

interface IRequiredTipProps {
	className?: string
}

const RequiredTip: FC<IRequiredTipProps> = ({className}) => {
	return (
		<p className={cx('required', className)}>
			<span className={cx('required__star')}>*</span>{' '}
			<span className={cx('required__text')}>Required filled</span>
		</p>
	)
}

RequiredTip.displayName = 'RequiredTip'

export default RequiredTip
